(function ($) {
    $(function () {
        //Function to add match height for any block
        $.addMatchHeight = function addMatchHeight(card, byRow = true) {
            if ($(window).width() < 768) {
                if (card.data('matchHeight') === 'true') {
                    card.data('matchHeight', 'false');
                    card.matchHeight({
                        remove: true
                    });
                }
            } else {
                if (
                    card.data('matchHeight') === 'false' ||
                    typeof card.data('matchHeight') === 'undefined'
                ) {
                    card.data('matchHeight', 'true');
                    card.matchHeight({
                        byRow: byRow
                    });
                }
            }
        };



        Fancybox.bind("[data-fancybox]", {
            Thumbs: {
                type: "classic",
            },
            Toolbar: {
                display: {
                    left: ["infobar"],

                    right: ["close"],
                },
            },

        });

        // Function to copy to clipboard
        function copyToClipboard(element) {
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val(element).select();
            document.execCommand('copy');
            $temp.remove();
        }

        $('.js-copy-link').on('click', function (e) {
            e.preventDefault();
            copyToClipboard(document.location.href);
        });

        //Go back to previous page button
        $('.js-go-back').on('click', function (e) {
            e.preventDefault();
            history.back();
        });

        //Unsubscribe animation
        $('.env-top-2-mobile').css("-webkit-animation-play-state", "paused");
        $(document).ready(function () {

            $('.env-top-2-mobile').css("-webkit-animation-play-state", "running");

        });
    });
})(jQuery);
